import request from '@/utils/request'

let Technical_training_signApi = {

  /*技术培训报名列表*/
  list(data) {
    return request._post('/shop/plus.technical_training_sign.Index/index', data);
},
/*添加技术培训报名*/
add(data) {
    return request._post('/shop/plus.technical_training_sign.Index/add', data);
},
/*修改技术培训报名*/
edit(data) {
    return request._post('/shop/plus.technical_training_sign.Index/edit', data);
},
/*删除技术培训报名*/
del(data) {
    return request._post('/shop/plus.technical_training_sign.Index/del', data);
},
/*技术培训报名详情*/
detail(data) {
  return request._post('/shop/plus.technical_training_sign.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.technical_training_sign.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.technical_training_sign.Setting/getSetting', data, errorback);
    },
}
export default Technical_training_signApi;



// WEBPACK FOOTER //
// ./src/api/technical_training_sign.js